import { tagName } from "@ember-decorators/component"
import Component from "@ember/component"
import { action } from "@ember/object"
import { inject as service } from "@ember/service"
import type { Planbook } from "@shared/models/planbook"
import { includes, isNil } from "lodash-es"

@tagName("")
export default class LessonMenuShareLink extends Component {
  // args
  cardStackId!: string
  planbook!: Planbook
  goBack!: Function

  //services
  @service router

  //state
  linkUrl = ""
  hasReceivedAttrs = false
  needsToConfirmLinkSharing = false
  menuName: "CANNOT_SHARE" | "CONFIRM_LINK_SHARING" | "SHOW_LINK" = "SHOW_LINK"

  // callbacks
  didReceiveAttrs() {
    if (this.hasReceivedAttrs || isNil(this.planbook)) return
    this.hasReceivedAttrs = true
    if (isNil(this.cardStackId)) {
      this.menuName = "CANNOT_SHARE"
      return
    }

    // this.linkUrl =
    // let path = getOwner(this)
    //   .lookup("router:main")
    //   .generate(`lesson`, {
    //     lessonId: this.cardStackId,
    //   })
    let path = this.router.urlFor("lesson", this.cardStackId)
    this.linkUrl = `${window.location.protocol}//${window.location.host}${path}`

    console.log("this.planbook", this.planbook.attributes.publicAccess)
    if (!includes(this.planbook.attributes.publicAccess.roles, "planbook:is-viewer")) {
      this.needsToConfirmLinkSharing = true
      this.menuName = "CONFIRM_LINK_SHARING"
    }
  }

  @action
  goBackFromShowLink() {
    if (this.needsToConfirmLinkSharing) {
      this.set("menuName", "CONFIRM_LINK_SHARING")
    } else {
      this.goBack()
    }
  }

  @action
  goToLink() {
    this.set("menuName", "SHOW_LINK")
  }
}
